<form
  #form
  [appApiAction]="formPromise"
  ngNativeValidate
  class="tw-flex tw-h-full tw-flex-col tw-gap-6"
>
  <div class="tw-rounded-xl tw-bg-color-surface-card tw-p-4 tw-shadow-elevation-card">
    <p class="tw-m-0 tw-mb-6 tw-text-sm tw-text-dt-text-secondary">
      {{ "twoStepLoginAuthDesc" | i18n }}
    </p>

    <div class="tw-flex tw-flex-col tw-gap-1">
      <div class="remove-bottom-space" [ngClass]="{ 'mat-form-field-error': passwordErrorText }">
        <app-user-verification
          [(ngModel)]="secret"
          ngDefaultControl
          name="secret"
          labelClass="tw-text-dt-text-secondary"
        >
        </app-user-verification>
      </div>
      <span *ngIf="passwordErrorText" class="tw-text-xs tw-text-dt-text-error">{{
        passwordErrorText | i18n
      }}</span>
    </div>
  </div>

  <app-gloss-button
    [options]="continueButtonOptions"
    class="tw-mt-auto tw-w-full"
  ></app-gloss-button>

  <!--  <div class="tw-mt-6 tw-flex tw-gap-2 xs:tw-flex-col">-->
  <!--    <app-gloss-button [options]="continueButtonOptions" class="button-resize"></app-gloss-button>-->
  <!--    <app-gloss-button-->
  <!--      [options]="cancelButtonOptions"-->
  <!--      data-dismiss="modal"-->
  <!--      class="button-resize sm:tw-hidden"-->
  <!--    ></app-gloss-button>-->
  <!--  </div>-->
</form>
